import { Box } from "@mui/material";
import URLinput from "./URLinput";
import { useSelector } from "react-redux";
import { Root } from "../../state/types";
import { QrType } from "../types";
import TextAreaInput from "./TextAreaInput";
import PhoneInput from "./PhoneInput";
import EmailInput from "./EmailInput";
import axios from "axios";


const InputResolver = () => {
    const typeSelector = useSelector((state: Root) => state.qrData.type);
    const qrData = useSelector((state: Root) => state.qrData);

    const record = async () => {
        try {
            await axios.post(`https://runtime-api.qrcompose.com/api/freewidget/${qrData.type}`, {
                ...qrData,
                type: `${qrData.type}`
            });
        } catch (error) {}
    }

    switch(typeSelector){
        case QrType.URL:
            return (<URLinput record={record} />);
        case QrType.TEXT:
            return (<TextAreaInput record={record} />);
        case QrType.PHONE:
            return(<PhoneInput record={record} />);
        case QrType.EMAIL:
            return(<EmailInput record={record} />);
    }

    return(null);
}

export default InputResolver;
